export default function guest({ next, store }) {
  if (store.getters['auth/token'] && store.getters['auth/userId']) {
    return next({ name: 'home' })
  }
  return next()
}
